<template>
  <div>
    <div v-if="breaches.length > 0">
      <h2>ATTENZIONE!</h2>
      <h3>IL TUO ACCOUNT È STATO COINVOLTO IN 
        <span style="color: red;">{{ breaches.length }}</span>
        <span v-if="breaches.length > 1">&nbsp;VIOLAZIONI!</span>
        <span v-else>&nbsp;VIOLAZIONE!</span>
      </h3>
      <div class="card" v-for="breach in breaches" :key="breach.Name">
        <h5 class="card card-header">{{ breach.Title }}</h5>
        <div class="card-body d-flex">
          <div class="col-8">
            <h5 class="card-title">Violazione subita il {{ monthTranslation(breach.BreachDate) }}</h5>
            <h5 class="card-title">Violazione segnalata il {{ monthTranslation(breach.AddedDate) }}</h5>
            <p class="card-title">Dati rubati: </p>
            <ul>
              <li v-for="dataClass in wordTranslation(breach.DataClasses)" :key="dataClass">
                {{ dataClass }}
              </li>
            </ul>
          </div>
          <div class="col-4 d-flex justify-content-center align-items-center">
            <img :src="breach.LogoPath" alt="logo" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="noBreachesFound" class="mt-4">
      <h2>Perfetto!</h2>
      <h3>Il tuo account al momento non risulta compromesso!</h3>
      <h3>Continua comunque a proteggere le tue password!</h3>
    </div>
    <div class="text-center">
      <BButton @click="reset" variant="success">Clicca per verificare un altro TUO indirizzo!</BButton>
    </div>
  </div>
</template>

<script>
import dati from '@/assets/traduzioni/dati.json';

export default {
  name: 'Results',
  props: {
    breaches: {
      type: Array,
      default: () => []
    },
    noBreachesFound: {
      type: Boolean,
      default: false
    }
  },
  emits: ['reset'],
  methods: {
    reset() {
      this.$emit('reset');
    },
    monthTranslation(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });
    },
    wordTranslation(dataClasses) {
      return dataClasses.map((dataClass) => dati[dataClass] || dataClass);
    }
  }
};
</script>

<style scoped>
.card-title {
  text-align: left;
  padding-left: 80px;
  color: white;
}

.card-header {
  text-align: center;
  color: white;
}

.card {
  background: rgba(255, 0, 0, 0.7); /* Change the background color to match the content-right background */
}

img {
  max-width: 100%;
  max-height: 100px;
}

ul {
  width: 70%;
  margin: 0 auto;
  text-align: left;
}

.cross li, .check li {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 18px;
}

@media (max-width: 768px) {
  .card-title {
    padding-left: 0;
  }
  ul {
    width: 100%;
  }
}
</style>